import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-252a2c72"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ee-inactive" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = {
  class: "row",
  style: {"display":"flex","justify-content":"center"}
}
const _hoisted_4 = { class: "col-md-6" }
const _hoisted_5 = { class: "inactive-ee-box" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-exclamation big-icon" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Inactivated Account", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createTextVNode(" Your account has been inactivated. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" if you have any questions regarding your account, please "),
  /*#__PURE__*/_createElementVNode("a", {
    class: "link",
    href: "https://www.lawsociety.com.au/contact-us",
    target: "_blank"
  }, "contact us"),
  /*#__PURE__*/_createTextVNode(". ")
], -1))
const _hoisted_11 = { class: "buttons" }

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _hoisted_7,
            _hoisted_8,
            _hoisted_9,
            _hoisted_10,
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("button", {
                class: "btn btn-outline mr-1",
                onClick: _cache[0] || (_cache[0] = _withModifiers($event => (_ctx.signOut()), ["prevent"]))
              }, "My Account")
            ])
          ])
        ])
      ])
    ])
  ]))
}